import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@merch-store/environments/environment';
import { Brand } from '@models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

const DEFAULT_BRAND_IDS = [
  1246, // Dyson
  1761, // Sony
  1678, // Ray-Ban
  1194, // Cuisinart
];

@Injectable({
  providedIn: 'root',
})
export class HeroImageDataService {
  private readonly http = inject(HttpClient);
  private readonly maxHeroImagesCount = 5;

  getHeroImages(brandIds = DEFAULT_BRAND_IDS, takeRandom = true): Observable<Brand[]> {
    const params = new HttpParams({
      fromObject: {
        page: 1,
        pageSize: this.maxHeroImagesCount,
        imageType: 'hero',
        takeRandom,
        brandIds,
      },
    });
    return this.http
      .get<{ items: Brand[] }>(environment.remoteApi + '/brands', { params })
      .pipe(map(({ items }) => items));
  }
}
